<template>
  <div class="content">
    <div class="i2p-new-page">
      <ed-title-nav ref='header' :title="$t(pageTitle)" :subtitle="$t(subtitle)">
        <snapshot
          :model="snapshotSettings"
          slot="overview"
        />
        <span slot="action">
          <a href="javascript:;" v-on:click="cancel()">
            <i class="fa fa-long-arrow-left"></i>
            <span>&nbsp; Back</span>
          </a>
        </span>

        <!-- Action Buttons -->
        <toolbar slot="toolbar">
          <ed-button
            button-class="btn btn-actionbar-primary pull-right"
            @click="validateAndSubmit()"
            :disabled="disablePaymentAction"
            v-if="!displaySendApFile"
            name='submit-payment'
            >{{ submitPaymentButton }}</ed-button>
          <ed-button
            button-class="btn btn-actionbar-primary pull-right"
            @click="sendApFiles()"
            :disabled="disablePaymentAction"
            v-if="displaySendApFile"
            name='submit-payment'
          >{{ 'Send' }}</ed-button>
          <ed-button
            button-class="btn btn-actionbar pull-right"
            @click="cancel()"
            name='cancel-payment'
          >{{ 'Cancel' }}</ed-button>
        </toolbar>

      </ed-title-nav>

      <!-- Page -->
      <div class="container-fluid">
        <br />

        <span class="step1" v-if="!displaySendApFile">
          <funding-information
            :model="getFundingInformationModel()"
            :errors="validationErrors"
            :invoiceModelCurrencies="getInvoiceModelCurrencies"
            :isFundingCurrencyDifferent="isFundingCurrencyDifferent"
            @fundingInfoChanged="fundingInfoChanged"
            />

          <span v-for="(division, index) in invoicesByDivisionOrBU" v-bind:key="division.DivisionOrBUName">
            <invoices
              :invoices="division.Invoices"
              :settings="getInvoicesSettings(division)"
              @makePaymentCurrencyConversion="doCurrencyConversion"
              @amountOnInvoiceWasChanged="amountOnInvoiceWasChanged"
              ref='invoicesComp'
              />

            <make-payment
              v-if="isMakePayment"
              :divisionKey="index"
              :model="division"
              :achInfo="settings.AchInfo"
              @paymentChanges="makePaymentFieldsChanges"
              @changeAddress="(d) => changeAddress(d, index)"
              />

            <post-payment
              v-if="isPostPayment"
              :divisionKey="index"
              :model="division"
              :paymentMethods="settings.paymentMethods"
              :userToken="user.token"
              @paymentChanges="postPaymentFieldsChanged"
              />
          </span>
        </span>

        <span class="step2" v-if="displaySendApFile">
          <span v-for="(item, i) in step2Models" :key="i">
            <invoices
              :invoices="filterInvoicesForStep2(item)"
              :settings="getApFileInvoicesSettings(item)"
              />

            <send-ap-file
              :emailSettings="item"
              :token="user.token"
              @apFileChanges="apFileChanges"
              @changeAddress="(d) => changeAddress(d, i)"
              />
          </span>
        </span>
      </div>

      <ed-modal
        :show='processingErrorModel.display'
        @close='processingErrorModel.display = false'
        title=''
        primaryButton='false'
        secondaryButton='Ok'
        type='large'
        name='processing_error'
      >
        <div slot="body">
          <p>{{processingErrorModel.headerLabel}}</p>
          <br />
          <table class="full-width simple">
            <thead>
              <th v-for="column in processingErrorModel.columns" v-bind:key="column" class="col-md-2">{{column}}</th>
            </thead>
            <tbody v-for="error in processingErrorModel.errors" v-bind:key="error">
              <tr>
                <td v-for="col in error" v-bind:key="col" class="col-md-2">
                  <a :href="col.url" v-if="col.url !== ''">{{col.message}}</a>
                  <span v-if="col.url === ''">{{col.message}}</span>
              </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ed-modal>
    </div>
  </div>

</template>

<script>

import { attach } from './override'
import { Eved, EventBus } from '@/event-bus'

import { default as legacySteps } from '@/components/LegacyContainer'
import toolbar from './Toolbar'

import invoices from './Invoices.vue'
// import invoiceModel from './models/invoices-model'

import fundingInformation from './FundingInformation.vue'
import makePayment from './MakePayment.vue'
import postPayment from './PostPayment.vue'
import sendApFile from './SendApFile.vue'

import snapshot from './Snapshot'
import snapshotModel from './models/snapshot-model'

import processingErrorModel from './models/error-model'

// import settingsModel from './models/settings-model'

export default {
  name: 'Payment',

  components: {
    legacySteps,
    invoices,
    snapshot,
    makePayment,
    postPayment,
    fundingInformation,
    sendApFile,
    toolbar
  },

  activated() {
    this.$nextTick(() => {
      this.highlightTabs()
      this.init()
    })
  },

  deactivated() {
    this.clearTabs()
  },

  beforeLeave() {
    return this.checkedBeforeLeave
  },

  data() {
    return {
      disablePaymentAction: false,
      displaySendApFile: false, // TODO
      invoicesByDivisionOrBU: [],
      step2Models: [],
      settings: {
        displayFundingCurrencies: false,
        hideFundingEquivalentMessage: false,
        showFundingAddress: false,
        fundingCurrencies: [],
        fundingCurrencyCode: '',
        paymentMethodId: 0,
        paymentMethods: [],
        hasAuditFile: true,
        hasFundingAddressAndAPTemplate: false,
        AchInfo: ''
      },
      snapshot: {
        count: 0,
        totalAmount: 0,
        currencyCode: utils.constants.invoice.USD
      },
      snapshotModel,
      processingErrorModel,
      user: {
        token: ''
      },
      approvalStatus: false,
      usdEquivalent: 0,
      paymentDate: global.moment(new Date()).format(this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat),
      validationErrors: {
        USDEquivalentMissing: false,
        ApprovalCheckboxError: false,
        PaymentDateMissing: false,
        FundingCurrency: false
      },
      checkedBeforeLeave: true,
      fundingAddress: {
        Venue: '',
        Address: '',
        Address2: '',
        CityStateZip: '',
        CountryName: '',
        VatNo: ''
      }
    }
  },

  computed: {
    snapshotSettings() {
      return snapshotModel
    },

    paymentType() {
      return this.$route.query.type
    },

    paymentKey() {
      let key = this.$route.query.key
      if (!key) {
        key = this.utils.cookie.get('PaymentKey')
      }
      return key
    },

    isMakePayment() {
      return this.paymentType === 'make'
    },

    isPostPayment() {
      return this.paymentType === 'post'
    },

    pageTitle() {
      return this.capitalize(this.paymentType) + ' Payment'
    },

    submitPaymentButton() {
      return this.isPostPayment ? 'Send' : 'Next'
    },

    subtitle() {
      return this.isMakePayment && this.settings.hasAuditFile
        ? (!this.displaySendApFile
          ? 'Payment Step 1 of 2'
          : 'Payment Step 2 of 2')
        : ''
    },

    getInvoiceModelCurrencies() {
      let currencyCodes = []

      this.invoicesByDivisionOrBU &&
      this.invoicesByDivisionOrBU.length &&
      this.invoicesByDivisionOrBU.map(div => {
        div.Invoices.map(i => {
          i.CurrencyCode && currencyCodes.push(i.CurrencyCode)
        })
      })

      // return distinct currencyCodes if there are duplicates
      return [...new Set(currencyCodes)]
    },

    isFundingCurrencyDifferent() {
      let result = false
      this.isMakePayment &&
      this.invoicesByDivisionOrBU &&
      this.invoicesByDivisionOrBU.length &&
      this.invoicesByDivisionOrBU.map(div => {
        div.Invoices.map(i => {
          if (i.CurrencyCode && i.FundingCurrencyCode && i.CurrencyCode !== i.FundingCurrencyCode) {
            result = true
          }
        })
      })

      return result
    }
  },

  methods: {
    capitalize(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },

    getInvoices(division) {
      return division.Invoices
    },

    back() {
      if (this.mustSave) {
        this.save()
      }
    },

    getFundingCurrencyCode(division) {
      if (this.isPostPayment) {
        return (this.invoicesByDivisionOrBU.length >= 1 &&
          this.invoicesByDivisionOrBU[0].Invoices &&
          this.invoicesByDivisionOrBU[0].Invoices.length >= 1 &&
          this.invoicesByDivisionOrBU[0].Invoices[0].CurrencyCode) || null
      }

      // Make payment
      if (!this.settings.displayFundingCurrencies && division &&
        division.Invoices && division.Invoices[0]) {
        return division.Invoices[0].FundingCurrencyCode
      }
      return this.settings.fundingCurrencyCode || ''
    },

    getInvoicesSettings(division) {
      return {
        divisionOrBUName: division.DivisionOrBUName,
        title: 'Selected Invoices',
        subtitle: this.isMakePayment
          ? 'Payments are grouped by Division. Specify your payment information below and click Next when complete.'
          : 'Payments are grouped by Division. Enter the payment method, the reference number if applicable, and any notes in the fields below.',
        editable: true,
        displayUSDEquivalent: this.isMakePayment && !this.settings.hideFundingEquivalentMessage,
        isMakePayment: this.isMakePayment,
        fundingCurrencyCode: this.getFundingCurrencyCode(division),
        isStep2: this.displaySendApFile
      }
    },

    getApFileInvoicesSettings(auditFile) {
      let division = this.getDivisionByName(auditFile.DivisionOrBUName)
      let hasTemplateName = (auditFile.AuditFileTemplateName || '') !== ''
      let isGroupedByTemplate = this.settings.hasFundingAddressAndAPTemplate && hasTemplateName

      return {
        divisionOrBUName: isGroupedByTemplate
          ? auditFile.AuditFileTemplateName
          : division.DivisionOrBUName,
        title: 'Message Details',
        subtitle: 'In addition to the selected user, enter the email address of each person or people you would like to copy (CC) or blind carbon copy (BCC) this statement to.',
        editable: false,
        displayUSDEquivalent: this.isMakePayment && !this.settings.hideFundingEquivalentMessage,
        isMakePayment: this.isMakePayment,
        displayDivisionOnExpand: this.isMakePayment && isGroupedByTemplate,
        fundingCurrencyCode: isGroupedByTemplate
          ? auditFile.FundingCurrencyCode
          : this.getFundingCurrencyCode(division),
        isStep2: this.displaySendApFile
      }
    },

    getFundingInformationModel() {
      return {
        currencies: this.settings.fundingCurrencies,
        displayFundingCurrencies: this.isMakePayment && this.settings.displayFundingCurrencies,
        hideFundingEquivalentMessage: this.settings.hideFundingEquivalentMessage,
        displayUSDEquivalent: this.isPostPayment,
        disableUSDEquivalent: this.allInvoicesAreInUSD(),
        usdEquivalent: this.usdEquivalent,
        disablePaymentDate: this.isMakePayment && !this.settings.AllowScheduledPayments && !this.settings.AllowPostingDate,
        hideDatePickerYesterdayLink: this.isMakePayment && (this.settings.AllowScheduledPayments || this.settings.AllowPostingDate),
        notBeforePaymentDate: this.isMakePayment ? new Date() : null
      }
    },

    amountOnInvoiceWasChanged() {
      this.setUsdEquivalentTotal()
      this.setSnapshotPaymentAmount()
    },

    setUsdEquivalentTotal() {
      if (this.isPostPayment) {
        if (this.allInvoicesAreInUSD()) {
          this.usdEquivalent = this.getInvoicesTotalAmountToPay()
        }
      }
    },

    allInvoicesAreInUSD() {
      let allInUSD = true
      this.invoicesByDivisionOrBU.map && this.invoicesByDivisionOrBU.map(div => {
        div.Invoices.map(inv => {
          if (inv.CurrencyCode !== 'USD') {
            allInUSD = false
          }
        })
      })
      return allInUSD
    },

    getInvoicesTotalAmountToPay() {
      let sum = 0
      this.invoicesByDivisionOrBU.map && this.invoicesByDivisionOrBU.map(div => {
        div.Invoices.map(inv => {
          sum += Number(inv.Amount) || 0
        })
      })
      return sum.toFixed(2)
    },

    filterInvoicesForStep2(auditFile, auditFileTemplateId) {
      var invoices = []
      Array.isArray(this.invoicesByDivisionOrBU) && this.invoicesByDivisionOrBU.map(div => {
        if (this.settings.hasFundingAddressAndAPTemplate &&
          (auditFile.AuditFileTemplateId || 0) > 0) {
          if ((div.AuditFileTemplateId || 0) === (auditFile.AuditFileTemplateId || 0) &&
            (this.step2Models.length === 1 || (div.FundingAddressId || 0) === (auditFile.FundingAddressId || 0)) &&
            div.Invoices && div.Invoices.length > 0 &&
            div.Invoices[0].FundingCurrencyCode === auditFile.FundingCurrencyCode &&
            (div.DivisionOrBUName === auditFile.BusinessUnitName || !auditFile.HasAPSettingsByBU)) {
            invoices = invoices.concat(div.Invoices)
          }
        } else if (div.DivisionOrBUName === auditFile.DivisionOrBUName) {
          invoices = div.Invoices
        }
      })
      return invoices
    },

    filterSameDayInvoicesForStep2(auditFile) {
      var invoices = []
      Array.isArray(this.invoicesByDivisionOrBU) && this.invoicesByDivisionOrBU.map(div => {
        if (this.settings.hasFundingAddressAndAPTemplate &&
          (auditFile.AuditFileTemplateId || 0) > 0) {
          if ((div.AuditFileTemplateId || 0) === (auditFile.AuditFileTemplateId || 0) &&
            (this.step2Models.length === 1 || (div.FundingAddressId || 0) === (auditFile.FundingAddressId || 0)) &&
            div.SameDayInvoices && div.SameDayInvoices.length > 0 &&
            div.SameDayInvoices[0].FundingCurrencyCode === auditFile.FundingCurrencyCode) {
            invoices = invoices.concat(div.SameDayInvoices)
          }
        }
      })
      return invoices
    },

    getDivisionByName(divisionOrBUName) {
      let division = {}
      Array.isArray(this.invoicesByDivisionOrBU) && this.invoicesByDivisionOrBU.map(div => {
        if (div.DivisionOrBUName === divisionOrBUName) {
          division = div
        }
      })
      return division
    },

    init() {
      this.displaySendApFile = false

      // TODO: REMOVE
      // this.goToStep2(JSON.stringify([{'16688': 'Division A <approval>'}]), null)

      return this.getInitAction()
        .then(response => {
          this.invoicesByDivisionOrBU = response.data.InvoicesByDivisionOrBU
          this.settings.displayFundingCurrencies = response.data.CanSelectFundingCurrency
          this.settings.hideFundingEquivalentMessage = response.data.HideFundingEquivalentMessage
          this.settings.fundingCurrencies = response.data.FundingCurrencies
          this.settings.showFundingAddress = response.data.ShowFundingAddress

          this.settings.fundingCurrencyCode = response.data.FundingCurrencyCode
          this.settings.paymentMethodId = response.data.PaymentMethodId
          this.settings.paymentMethods = response.data.PaymentMethods

          this.settings.hasAuditFile = response.data.HasAuditFile
          this.settings.hasFundingAddressAndAPTemplate = response.data.HasFundingAddressAndAPTemplate
          this.settings.AchInfo = response.data.AchInfo
          this.settings.AllowScheduledPayments = response.data.AllowScheduledPayments
          this.settings.AllowPostingDate = response.data.AllowPostingDate

          this.initSnapshot()

          this.setUsdEquivalentTotal()

          this.user.token = response.data.Token

          this.doCurrencyConversion({
            CurrencyCode: response.data.FundingCurrencyCode
          })
        })
    },

    getInitAction() {
      return this.paymentKey.length > 1900
        ? this.api.post(this.api.$.payment.init, {
          key: this.paymentKey,
          paymentType: this.paymentType
        })
        : this.api.get(this.api.$.payment.init, {
          params: {
            key: this.paymentKey,
            paymentType: this.paymentType
          }
        })
    },

    initSnapshot() {
      this.setSnapshotPaymentsNo()
      this.setSnapshotPaymentAmount()
    },

    setSnapshotPaymentsNo() {
      let count = 0
      this.invoicesByDivisionOrBU && this.invoicesByDivisionOrBU.map(div => {
        count += div.Invoices.length
      })

      this.snapshotModel.count = count
    },

    setSnapshotPaymentAmount() {
      let paymentAmount = 0
      let fundCurrencyCode = null

      this.invoicesByDivisionOrBU && this.invoicesByDivisionOrBU.map(div => {
        div.Invoices.map(inv => {
          if (!inv.IsSameDayDeposit) {
            if (fundCurrencyCode === null) {
              fundCurrencyCode = this.getFundingCurrencyCode(div)
            }
            paymentAmount += Number(this.isPostPayment || inv.CurrencyCode === fundCurrencyCode ? inv.Amount : inv.AmountUSD) || 0
          }
        })
      })

      this.snapshotModel.totalAmount = paymentAmount
      this.snapshotModel.currencyCode = fundCurrencyCode
    },

    resetJSONmodel() {
      // reset submission approval
      this.approvalStatus = false
    },

    cancel(checkedBeforeLeave) {
      this.checkedBeforeLeave = checkedBeforeLeave || false
      let tab = ''
      let subtab = ''
      let url = '/i/Programs/Invoice-received/'
      if (this.$route.query.from) {
        if (this.$route.query.from.toLowerCase().trim() === 'programinvoices') {
          // Program dashboard > Invoices tab
          url = '/i/Programs/Program-list/?goto=PaymentInvoice/ProgramInvoiceList/' +
            (typeof this.$route.query.programId !== 'undefined' ? this.$route.query.programId : 0)
          tab = 'Commerce'
          subtab = 'Invoices'
        } else if (this.$route.query.from.toLowerCase().trim().indexOf('poinvoices') === 0) {
          // PO Details > Invoices tab
          url = '/i/Programs/Program-list/?goto=PaymentInvoiceFusion' +
            (typeof this.$route.query.poId !== 'undefined' ? this.$route.query.poId : 0)
          tab = 'Commerce'
          subtab = 'ProgramList'
        }
      }
      if (tab !== '' && subtab !== '') {
        this.$root.legacyTab = tab
        this.$root.legacySubtab = subtab
      }
      this.$router.push(url)
    },

    validate() {
      let valid = this.approvalStatus
      // Payment Date
      if (!this.paymentDate) {
        this.validationErrors.PaymentDateMissing = true
        valid = false
      } else {
        this.validationErrors.PaymentDateMissing = false
      }

      // Approval checkbox
      if (!this.approvalStatus) {
        this.validationErrors.ApprovalCheckboxError = true
      } else {
        this.validationErrors.ApprovalCheckboxError = false
      }

      if (this.isMakePayment) {
        if (this.settings.fundingCurrencyCode === null ||
          this.settings.fundingCurrencyCode === ''
        ) {
          this.validationErrors.FundingCurrency = true
          valid = false
        }
      }

      if (this.isPostPayment) {
        this.invoicesByDivisionOrBU.map(div => {
          EventBus.$emit(Eved.PAYMENT.VALIDATE_POST_PAYMENT_FIELDS + this.invoicesByDivisionOrBU.indexOf(div))

          // Paid By
          if (div.DisplayPaidBy && (!div.PaidBy || div.PaidBy === null ||
            div.PaidBy === '')) {
            valid = false
          }

          // Payment Method
          if ((div.PaymentMethodId || 0) === 0) {
            valid = false
          }

          // Reference No
          if (!div.ReferenceNo || div.ReferenceNo === null ||
            div.ReferenceNo === '') {
            valid = false
          }

          // Cost Center
          if (div.ValidateCostCenter && div.CostCenters.length > 0 && (div.CostCenterId || 0) === 0) {
            valid = false
          }
        })
      }

      // validate grid values
      let invalidGrid = false
      this.$refs.invoicesComp.map(div => {
        if (div.$refs.PaymentInvoices.validateCells()) {
          invalidGrid = true
        }
      })

      if (invalidGrid) {
        valid = false
      }
      this.checkedBeforeLeave = true
      return valid
    },

    validateAndSubmit() {
      let valid = this.validate()
      if (valid) {
        this.submit()
      } else {
        this.showErrorPopup()
      }
    },

    showErrorPopup() {
      if (this.validationErrorTitle) {
        this.showValidationError = true
      }
    },

    getInfoToSubmitPayments() {
      let paymentInfo = []
      let amountsByEvent = {}
      let paymentMethodId = this.settings.paymentMethodId

      this.invoicesByDivisionOrBU.map(div => {
        let itemInfo = {
          ReceiverID: 0,
          HasUSDEquivalent: !this.isPostPayment,
          currencyCode: this.settings.fundingCurrencyCode,
          paymentMethod: div.PaymentMethodId || paymentMethodId,
          paymentNotes: div.PaymentNotes,
          auditFileTemplateId: div.AuditFileTemplateId,
          fundingAddressId: div.FundingAddressId
        }

        if (this.isPostPayment) {
          if (div.ValidateCostCenter) {
            itemInfo.costCenter = div.CostCenterId || ''
          }
          itemInfo.referenceNo = div.ReferenceNo
          if (div.DisplayPaidBy) {
            itemInfo.paymentMethodMSP = div.PaidBy
          }
          itemInfo.attachmentFile = div.Attachment.AttachmentFile
          itemInfo.attachmentSize = div.Attachment.AttachmentSize
          itemInfo.attachmentName = div.Attachment.AttachmentName
        }

        let receiverVendorIds = []
        let invoiceIds = []

        div.Invoices.map(inv => {
          itemInfo.PaymentNote = inv.PaymentNote

          if (receiverVendorIds.indexOf(inv.SupplierVendorId) === -1) {
            receiverVendorIds.push(inv.SupplierVendorId)
          }

          invoiceIds.push(inv.PaymentInvoiceId)

          inv.Events.map(ev => {
            amountsByEvent[ev.InvoiceRequestPaymentId] = ev.Balance
          })
        })

        if (receiverVendorIds.length > 1) {
          itemInfo.ReceiverIDList = receiverVendorIds.join(',')
        } else if (receiverVendorIds.length === 1) {
          itemInfo.ReceiverID = receiverVendorIds[0]
        }

        itemInfo.ItemIDList = invoiceIds.join(',')

        paymentInfo.push(itemInfo)
      })

      return {
        paymentInfo,
        amountsByEvent
      }
    },

    submit() {
      let data = this.getInfoToSubmitPayments()

      // disable action
      this.disablePaymentAction = true

      this.api
        .post(this.api.$.payment.submit, {
          key: this.paymentKey,
          paymentInfo: data.paymentInfo,
          amountsByEvent: data.amountsByEvent,
          paymentType: this.paymentType,
          fundingCurrencyCode: this.settings.fundingCurrencyCode,
          usdEquivalent: this.usdEquivalent,
          paymentDate: this.paymentDate,
          fundingAddress: this.fundingAddress
        })
        .then(response => {
          let msg = response.data.SuccessMessage

          // re-enable action
          this.disablePaymentAction = false

          if (msg === 'Error') {
            this.showProcessingError(response.data.Data)
          } else if (msg === 'SetupAuditFile') {
            this.goToStep2(response.data.Data, null)
          } else if (msg === 'SendFundingInvoice') {
            this.goToStep2(null, response.data.Data)
          } else {
            this.cancel(true)
          }
        }).catch(e => {
          this.disablePaymentAction = false
        })
    },

    showProcessingError(r) {
      if (!r || r === null || r === '') {
        this.processingErrorModel.display = true
        this.processingErrorModel.headerLabel = 'Something went wrong.'
      } else {
        this.processingErrorModel.display = true
        this.processingErrorModel.errors = []

        let errors = JSON.parse(r)

        for (let i = 0; i < errors.length; i++) {
          if (i === 0) {
            // Main Error
            this.processingErrorModel.headerLabel = errors[i].Message
          } else if (i === 1) {
            // header
            this.processingErrorModel.columns = errors[i].Message.split('_____')
          } else {
            // invoices with error
            let items = errors[i].Message.split('_____')
            let rows = []
            for (let k = 0; k < items.length; k++) {
              let err = {
                message: items[k],
                url: ''
              }
              if (err.message && err.message.indexOf('[') !== -1 &&
                err.message.indexOf(']') !== -1) { // has URL
                let arr = err.message.split('[')
                err.message = arr[0]
                err.url = arr[1].replace(']', '')
              }
              rows.push(err)
            }
            this.processingErrorModel.errors.push(rows)
          }
        }
      }
    },

    formatStep2Parameter(apFileIdsByDivision, fundingInvoiceIdsByDivision) {
      let itemsToProcess = []

      if (apFileIdsByDivision != null) {
        let ids = JSON.parse(apFileIdsByDivision)
        for (let key in ids) {
          if (ids.hasOwnProperty(key)) {
            itemsToProcess.push({
              AuditFileId: Number(key) || 0,
              DivisionOrBUName: ids[key]
            })
          }
        }
      }

      if (fundingInvoiceIdsByDivision != null) {
        let ids = JSON.parse(fundingInvoiceIdsByDivision)
        for (let key in ids) {
          if (ids.hasOwnProperty(key)) {
            itemsToProcess.push({
              FundingInvoiceId: Number(key) || 0,
              DivisionOrBUName: ids[key]
            })
          }
        }
      }

      return itemsToProcess
    },

    goToStep2(apFileIdsByDivision, fundingInvoiceIdsByDivision) {
      let itemsToProcess = this.formatStep2Parameter(apFileIdsByDivision, fundingInvoiceIdsByDivision)

      this.api
        .post(this.api.$.payment.initApFiles, {
          ids: itemsToProcess
        })
        .then(response => {
          this.step2Models = response.data
          this.displaySendApFile = true
        })
    },

    getInfoToSendApFiles() {
      let result = []

      this.step2Models.map(itm => {
        result.push({
          AuditFileId: itm.ApFileId,
          FundingInvoiceId: itm.FundingInvoiceId,
          /* AuditFileTemplateId: itm.AuditFileTemplateId,
          FundingAddressId: itm.FundingAddressId, */
          Cc: itm.Cc,
          Bcc: itm.Bcc,
          Message: itm.Message,
          Attachments: itm.Attachments,
          FundingAddress: this.fundingAddress
        })
      })

      return result
    },

    async sendApFiles() {
      this.disablePaymentAction = true

      try {
        let data = this.getInfoToSendApFiles()
        await this.checkPaymentProcessingFinished(data)

        this.api
          .post(this.api.$.payment.sendApFiles, {
            auditFiles: data
          })
          .then(response => {
            this.disablePaymentAction = false
            this.resetFundingAddress()
            this.cancel(true)
          }).catch(e => {
            this.disablePaymentAction = false
          })
      } catch (e) {}
    },

    async resetFundingAddress() {
      this.fundingAddress = {
        Venue: '',
        Address: '',
        Address2: '',
        CityStateZip: '',
        CountryName: '',
        VatNo: ''
      }
    },

    async checkPaymentProcessingFinished(data) {
      let isPaymentProcessingFinished = true
      await this.api
        .post(this.api.$.payment.checkPaymentProcessingFinished, {
          auditFiles: data
        })
        .then(response => {
          let msg = response.data.SuccessMessage

          if (msg === 'Error') {
            this.showCheckProcessingError()
            // re-enable action
            this.disablePaymentAction = false
            isPaymentProcessingFinished = false
          }
        }).catch(e => {
          this.disablePaymentAction = false
        })
      if (!isPaymentProcessingFinished) {
        throw new Error('Processing did not finish')
      }
    },

    showCheckProcessingError() {
      global.alert('The funding statement has not been fully generated, please try again in a few seconds.')
    },

    apFileChanges(e) {
      this.step2Models.map(itm => {
        if (itm.DivisionOrBUName === e.divisionOrBUName) {
          itm.Cc = e.cc
          itm.Bcc = e.bcc
          itm.Message = e.message
          itm.Attachments = e.attachments
        }
      })
    },

    fundingInfoChanged(e) {
      if (typeof e.Approval === 'boolean') {
        this.approvalStatus = e.Approval
        if (e.From &&
        utils.constants.invoice.ApprovalCheckbox &&
        e.From === utils.constants.invoice.ApprovalCheckbox) {
          return
        }
      }

      if (typeof e.CurrencyCode === 'string' && e.CurrencyCode !== '') {
        this.settings.fundingCurrencyCode = e.CurrencyCode

        this.doCurrencyConversion(e)
      }

      if (typeof e.USDEquivalent === 'number') {
        this.usdEquivalent = e.USDEquivalent
        if (this.usdEquivalent !== 0) {
          this.validationErrors.USDEquivalentMissing = false
        }
      }

      if (typeof e.PaymentDate === 'string') {
        this.paymentDate = e.PaymentDate
      }

      this.emitRefreshCurrencyChanged()
    },

    emitRefreshCurrencyChanged() {
      this.$refs.invoicesComp && this.$refs.invoicesComp.forEach(div =>
        div.$emit(Eved.PAYMENT.FUNDING_CURRENCY_CHANGED)
      )
    },

    doCurrencyConversion(e, cb) {
      let paymentInvoiceId = e.PaymentInvoiceId
      let fundingCurrencyCodeGlobal = e.CurrencyCode

      let conversionData = {
        Divisions: []
      }

      this.invoicesByDivisionOrBU.map(div => {
        if (div.Invoices.length > 0) {
          let fundingCurrencyCode = this.settings.displayFundingCurrencies
            ? fundingCurrencyCodeGlobal // selected currency at payment run
            : div.Invoices[0].FundingCurrencyCode /* TODO: add variable to div */ || fundingCurrencyCodeGlobal // currency at division level (or the global one)

          var division = this.createDivisionConversionObj(div, fundingCurrencyCode)

          // Invoices
          div.Invoices.map(invoice => {
            if ((paymentInvoiceId && invoice.PaymentInvoiceId === paymentInvoiceId) || !paymentInvoiceId) {
              division.Invoices.push(this.createInvoiceConversionObject(invoice))
            }
          })

          conversionData.Divisions.push(division)
        }
      })

      this.changeFundingCurrency(conversionData, cb)
    },

    createDivisionConversionObj(division, fundingCurrencyCode) {
      return {
        DivisionId: division.Invoices[0].DivisionId,
        BusinessUnitId: division.Invoices[0].BusinessUnitId,
        DivisionOrBUName: division.DivisionOrBUName,
        FundingCurrencyCode: fundingCurrencyCode,
        Invoices: []
      }
    },

    createInvoiceConversionObject(invoice) {
      return {
        ItemID: invoice.PaymentInvoiceId,
        CurrencyCode: invoice.CurrencyCode,
        ToPayAmount: invoice.Amount
      }
    },

    changeFundingCurrency(conversionData, cb) {
      this.api
        .post(this.api.$.payment.changeFundingCurrency, {
          conversionData: conversionData
        })
        .then(response => {
          if (response.SuccessMessage !== 'Error') {
            this.changeInvoiceModelAfterConversion(response.data, cb)
            this.setSnapshotPaymentAmount()
          }
        })
    },

    changeInvoiceModelAfterConversion(paymentObj, cb) {
      let match = null

      paymentObj &&
      paymentObj.Divisions &&
      paymentObj.Divisions.map(item => {
        this.invoicesByDivisionOrBU = this.invoicesByDivisionOrBU.map(div => {
          // match divisions
          if (div.DivisionOrBUName === item.DivisionOrBUName) {
            item.Invoices.map(paymentOnCurrencyItem => {
              div.Invoices = div.Invoices.map(invoice => {
                // match invoices
                if (invoice.PaymentInvoiceId === paymentOnCurrencyItem.ItemID) {
                  invoice.AmountUSD = paymentOnCurrencyItem.ToPayAmountFundedCurrency
                  match = div.Invoices
                  if (this.settings.displayFundingCurrencies) {
                    invoice.FundingCurrencyCode = item.FundingCurrencyCode
                  }
                }
                return invoice
              })
              return paymentOnCurrencyItem
            })
          }
          return div
        })
      })
      //
      if (match && match.length) {
        typeof cb === 'function' && cb(match)
      }
    },

    makePaymentFieldsChanges(e) {
      this.invoicesByDivisionOrBU.map(div => {
        if (div.DivisionOrBUName === e.divisionOrBUName) {
          div.PaymentNote = e.note
          div.PaymentMethodId = this.settings.paymentMethodId
        }
      })
    },

    postPaymentFieldsChanged(e) {
      this.invoicesByDivisionOrBU.map(div => {
        if (div.DivisionOrBUName === e.divisionOrBUName) {
          div.PaymentMethodId = e.paymentMethodId
          div.PaymentNotes = e.note
          div.ReferenceNo = e.referenceNo
          div.CostCenterId = e.costCenterId
          div.ValidateCostCenter = e.validateCostCenter
          div.PaidBy = e.paidBy
          div.Attachment = e.attachment
        }
      })
    },

    highlightTabs() {
      this.$root.legacyTab = 'Commerce'
      this.$root.legacySubtab = 'Invoices'
    },

    clearTabs() {
      this.$nextTick(() => {
        this.$root.legacyTab = this.$root.legacySubtab = ''

        this.invoicesByDivisionOrBU = {}
        this.usdEquivalent = 0
        this.settings.displayFundingCurrencies = false
        this.settings.hideFundingEquivalentMessage = false
        this.settings.fundingCurrencies = []
        this.settings.fundingCurrencyCode = ''
        this.settings.paymentMethodId = 0
        this.settings.hideFundingEquivalentMessage = false
        this.settings.hasFundingAddressAndAPTemplate = false
        this.settings.showFundingAddress = false
        this.snapshotModel.count = 0
        this.snapshotModel.totalAmount = 0
        this.snapshotModel.currencyCode = null

        this.processingErrorModel.display = false

        this.validationErrors.USDEquivalentMissing = false
        this.validationErrors.ApprovalCheckboxError = false
        this.validationErrors.PaymentDateMissing = false
        this.validationErrors.FundingCurrency = false
      })
    },

    changeAddress(d, i) {
      this.fundingAddress = d
      this.invoicesByDivisionOrBU[i].FundingAddresses[0].Value = d
    }
  }
}

attach()

</script>



// WEBPACK FOOTER //
// src/components/_modules/Payment/index.vue